import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action} from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, {FormBody, FormActions, TextInput, SelectInput} from '../../../Form';

@inject('workOrderStore', 'inventoryItemStore', 'userStore')
@observer
class WorkOrderTaskEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = `/monitoring/work_order/tabular/${this.props.workOrder_id}/view/tasks`;
  title = 'Edit Work Order Task';

  @observable item = {
    id: null,
    description: '',
    item_id: null,
    assigned_to: null,
    estimated_man_hours: null,
    hours_spent: null,
    task_result: '',
    task_status: ''
  };

  @action onChangeItem = e => this.item.item_id = +e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeAssignedTo = e => this.item.assigned_to = +e.target.value;
  @action onChangeEstimatedManHours = e => this.item.estimated_man_hours = +e.target.value;
  @action onChangeHoursSpent = e => this.item.hours_spent = +e.target.value;
  @action onChangeTaskResult = e => this.item.task_result = e.target.value;
  @action onChangeTaskStatus = e => this.item.task_status = e.target.value;

  constructor(props) {
    super(props);

    const {params: {id}, workOrderStore} = props;

    workOrderStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const {params: {task_id}, workOrderStore} = this.props;
    this.item = workOrderStore.findByTaskId(task_id);
  }

  handleSave = (e) => {
    e.preventDefault();

    const {workOrderStore, workOrder_id} = this.props;
    workOrderStore.updateTaskItem(workOrder_id, this.item.id, this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  };

  render() {
    const {workOrderStore, inventoryItemStore, userStore} = this.props;

    if (workOrderStore.isLoading) {
      return <Spinner/>;
    }

    return (
      <Modal title={this.title} slug={this.slug}>
        <Form>
          <FormBody>
            <TextInput label='Id' value={this.item.id} readOnly/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <SelectInput label='Item' value={this.item.item_id} options={inventoryItemStore.items} fields={{value: 'id', label: 'serial_no'}} onChange={this.onChangeItem}/>
            <SelectInput label='Assigned To' value={this.item.assigned_to} options={userStore.items} fields={{value: 'id', label: 'name'}} onChange={this.onChangeAssignedTo}/>
            <TextInput label='Estimated Man Hours' value={this.item.estimated_man_hours} onChange={this.onChangeEstimatedManHours}/>
            <TextInput label='Hours Spent' value={this.item.hours_spent} onChange={this.onChangeHoursSpent}/>
            <TextInput label='Task Result' value={this.item.task_result} onChange={this.onChangeTaskResult}/>
            <TextInput label='Task Status' value={this.item.task_status} onChange={this.onChangeTaskStatus}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default WorkOrderTaskEdit;


// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/Task/WorkOrderTaskEdit.js